



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const ADDPOSTRESUME= createAsyncThunk(
  "addpostresume/addpostresume",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const addpostresumeSlice = createSlice({
  name: "addpostresumeSlice",
  initialState: {
    addpostresume: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfaddpostresume: (state) => {
        state.addpostresume.loading = false
        state.addpostresume.error = false
        state.addpostresume.data = []
        state.addpostresume.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ADDPOSTRESUME.fulfilled, (state, action) => {
      state.addpostresume = {
        ...state.addpostresume,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDPOSTRESUME.pending, (state, action) => {
      state.addpostresume = {
        ...state.addpostresume,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDPOSTRESUME.rejected, (state, action) => {
      state.addpostresume = {
        ...state.addpostresume,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const addpostresumeAction = {
    ADDPOSTRESUME,
};

export { addpostresumeAction };
export default addpostresumeSlice.reducer;
export const {setInitialStateOfaddpostresume} = addpostresumeSlice.actions
